import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import Tippy from "@tippyjs/react";
import { ReactComponent as PDFIcon } from "../../../../../assets/utils/images/svgs/PDF.svg";
import { useDownloadWeekstaatReport } from "Api/Coordinator/Weekstaten";

const WeekReportDetails = ({ reportData }) => {
      const [downloadId, setDownloadId] = useState(null);
   
     const {
        data: downloadData,
        isLoading,
    } = useDownloadWeekstaatReport(downloadId);

    const downloadReport = (id) => {
        setDownloadId(id);
    };

    useEffect(() => {
        if (downloadData?.file?.download) {
            const downloadLink = document.createElement("a");

            downloadLink.href = downloadData.file.download;
            downloadLink.download = "weekstaat-report.pdf";

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            setDownloadId(null);
        }
    }, [downloadData]);

    const showSchoolData = (school) => {
        const withAddress = [school.school, school.vVisitoraddress]
            .filter((e) => e)
            .join(", ");

        let withCommunity;
        if (school.communityName) {
            withCommunity = withAddress.concat(" (", school.communityName, ")");
        }

        return school.school
            ? onHover(withAddress, withCommunity)
            : "---";
    };

    const onHover = (data, content) => (
        <Tippy content={content ?? data} placement="bottom">
            <span>{data}</span>
        </Tippy>
    );

    if (!reportData) return null;

    return (
        <Fragment>
            <Card className="main-card mb-3">
                <CardBody className="p-3 weekstat-data" style={{ minHeight: "450px" }}>
                    <h6 className="text-blue mb-3">Weekstaat {reportData.wssid}</h6>

                    <div className="row">

                        <div className="col-6 mb-2 fw-b">Bestuur</div>
                        <div className="col-6 text-end mb-2">{reportData.organisation ? onHover(reportData.organisation.split(' tot ')[0]) : "---"}</div>

                        <div className="col-6 mb-4 fw-b">School</div>
                        <div className="col-6 text-end mb-4">{showSchoolData(reportData)}</div>

                        <div className="col-6 mb-2 fw-b">Startdatum</div>
                        <div className="col-6 text-end mb-2">
                            {reportData.periode ? onHover(reportData.periode.split(" tot ")[0]) : "--"}
                        </div>

                        <div className="col-6 mb-4 fw-b">Einddatum</div>
                        <div className="col-6 text-end mb-4">
                            {reportData.periode ? onHover(reportData.periode.split(" tot ")[1]) : "--"}
                        </div>

                        <div className="col-6 mb-2 fw-b">Aangemaakt door</div>
                        <div className="col-6 text-end mb-2">
                            {reportData.createdby?.replace(/\-/g, "") ? onHover(reportData.createdby) : "--"}
                        </div>

                        <div className="col-6 mb-4 fw-b">Datum aangemaakt</div>
                        <div className="col-6 text-end mb-4">
                            {reportData.createdate ? onHover(reportData.createdate) : "--"}
                        </div>

                        <div className="col-6 mb-2 fw-b">Afgemeld door</div>
                        <div className="col-6 text-end mb-2">
                            {reportData.closedby ? onHover(reportData.closedby) : "--"}
                        </div>

                        <div className="col-6 mb-4 fw-b">Datum afgemeld</div>
                        <div className="col-6 text-end mb-4">
                            {reportData.closedDate ? onHover(reportData.closedDate) : "--"}
                        </div>

                        <div className="col-6 mb-4 fw-b">Herinneringsmail</div>
                        <div className="col-6 text-end mb-4">
                            {reportData.vMelderReminder ? onHover(reportData.vMelderReminder) : "---"}
                        </div>
                        <div className="col-6 mb-4 fw-b">Download</div>
                        <div className="col-6 text-end mb-4">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                     downloadReport(reportData.wssid);
                                }}
                                download
                            >
                                <PDFIcon />
                            </a>
                        </div>

                        <div className="col-6 mb-4 fw-b">Verstuurd naar</div>
                        <div className="col-6 text-end mb-4">
                            {reportData.emails?.toString() ? onHover(reportData.emails.toString()) : "--"}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default WeekReportDetails;